module.exports = __webpack_public_path__ + "1aade435060a75967646a29527322785.png";